module.exports = __webpack_public_path__ + "img/a747fc7e358bcb76c09b7941607e92a7.png";